import { userSettingsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  data() {
    return {
      showIvaConfirmation: false,
      pendingSettings: null,
    };
  },

  methods: {
    async onSettingsUpdate(newSettings) {
      if (!this.settings.voiceResponse && newSettings.voiceResponse) {
        const accountId = this.$store.state.currentAccountId;
        const settings = await userSettingsService.getUserSettings();
        if (settings.ivaConsentAcknowledged && settings.ivaConsentAcknowledged[accountId]) {
          this.settings = newSettings;
          this.updateNodeParent();
          return;
        }

        this.pendingSettings = newSettings;
        if (this.showIvaConfirmation) return;
        this.showIvaConfirmation = true;
      } else {
        this.settings = newSettings;
        this.updateNodeParent();
      }
    },

    async onIvaConfirm(confirmed) {
      if (confirmed) {
        const accountId = this.$store.state.currentAccountId;
        const settings = await userSettingsService.getUserSettings();
        if (!settings.ivaConsentAcknowledged) {
          settings.ivaConsentAcknowledged = {};
        }
        settings.ivaConsentAcknowledged[accountId] = true;
        userSettingsService.saveUserSettings(settings);

        this.settings = this.pendingSettings;
        this.updateNodeParent();
      } else {
        this.settings = { ...this.settings };
      }
      this.showIvaConfirmation = false;
    },
  },
};
